import { Modal as MaterialModal } from '@material-ui/core'
import { ModalProps } from '@material-ui/core/Modal'
import React, { useCallback, useEffect, useState } from 'react'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import styled from '../../../theme'

const MMFlex = ({ ...props }: ModalProps) => {
  const [modalDocument, setModalDocument] = useState(null as HTMLElement)
  const ref = useCallback(node => {
    if (node) {
      setModalDocument(node.querySelector('[role=document]'))
    }
  }, [])

  useEffect(() => {
    if (modalDocument) {
      props.open
        ? disableBodyScroll(modalDocument)
        : enableBodyScroll(modalDocument)
    }
    return () => {
      // eslint-disable-next-line
      if (modalDocument) {
        enableBodyScroll(modalDocument)
      }
    }
    // eslint-disable-next-line
  }, [])

  return <MaterialModal ref={ref} {...props} />
}

const ModalFlexOverflow = styled(MMFlex)`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
    outline: 0 !important;
`

export default ModalFlexOverflow
